import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SEOPageTitle from 'components/shared/SEOPageTitle';
import OrgManagerList from 'components/org-manager-admin/OrgManagerList';
import AppBarContext from 'context/AppBarContext';

/**
 * Panel admin "Prometeo": alta y baja de los gestores (contactos de RRHH) que ven el CRM
 * de bienestar de su empresa.
 */
function OrgManagersAdminPage() {
  const { t } = useTranslation(['routes']);
  const { setAppBarButton, setAppBarTitle } = useContext(AppBarContext);
  const pageTitle = t('orgManagers', { ns: 'routes', defaultValue: 'Prometeo' });

  useEffect(() => {
    setAppBarButton(null);
    setAppBarTitle(pageTitle);
  }, [pageTitle, setAppBarButton, setAppBarTitle]);

  return (
    <>
      <SEOPageTitle title={pageTitle} />
      <OrgManagerList />
    </>
  );
}

export default OrgManagersAdminPage;
